import qs from 'querystring';

const getReferringMedium = (query) => {
    query = query || qs.parse(window.location.search.substr(1));
    return query.utm_medium ? query.utm_medium.toLowerCase() : '';
};

export const isAmpReferrer = () => document.referrer.match(/\/amp\//g) !== null;

export const isEmailReferrer = (query) => {
    return getReferringMedium(query) === 'email';
};

export const isPlaReferrer = () => {
    const query = qs.parse(window.location.search.substr(1));
    return getReferringMedium() === 'pla' || (typeof query.product !== "undefined" && typeof query.gclid !== "undefined");
};



// WEBPACK FOOTER //
// ./src/notificationQueue/globalNotifications/helpers/referrerHelper.js